import React, { useState, useEffect } from 'react';
import SideBar from '../../Components/AdminDashboard/Admincommon/SideBar';
import Header from '../../Components/AdminDashboard/Admincommon/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/admin/admin_assets/css/sb-admin-2.min.css';
import '../../../src/pages/admin/admin_assets/css/common.css';
import '../../../src/pages/admin/admin_assets/css/responsive.css';
import '../../../src/pages/admin/admin_assets/css/Configure.css';
import HideText from '../../Components/AdminDashboard/Admincommon/HidePageText';
import Template from '../../Components/AdminDashboard/AdminSurveyTemplate/Template';

const SurveysPage = () => 
{

  
  
      const baseClass = 'container-fluid';
    
      const className = `${baseClass} `;
  
  // const navigate = useNavigate();
  //   const location = useLocation();

  //   useEffect(() => {
  //       const token = sessionStorage.getItem('userId');
  //       if (!token) {
  //           navigate('/');
  //       }
  //   }, [navigate]);

    
    const [hasMargin, setHasMargin] = useState(true)

    useEffect(()=>{
        function removeMargin(){
                setHasMargin(false)
        }
        removeMargin()
    })  

    return (
        <div id="page-top">
        <div id="wrapper" className='admin_sidebar'>
          <SideBar />
          <div id="content-wrapper" className={`d-flex flex-column ${hasMargin ? 'has-margin' : ''}`}>
            <div id="content" className={className}>
              <Header />
              <Template  />
      
            </div>
          </div>
        </div>
        <HideText/>
      </div>
    );
};

export default SurveysPage;